import React from 'react';
import { Modal,  Dropdown, Input, Button } from 'synapsefi-dev-ui';
import { ReactComponent as Xbtn} from '../../../../assets/svgs/Xbtn.svg';
import map from 'lodash/map';
import styled, {css} from 'styled-components';
import { advFormFields } from '../data/dataForAccounts';

const StyledModal = styled(Modal)`
  width: 80vw;
  border-radius: 5px;

  .syn-dev-ui-modal-header {
    height: 80px;
  }

  .syn-dev-ui-button-focus-container {
    padding: 3px 12px;
  }

  .syn-dev-ui-modal-footer {
    padding: 40px;
    padding-top: 0px;
  }

  .syn-dev-ui-modal-body {
    padding: 50px 40px 10px;
  }
`;

const ModalFormGrid = styled.div`
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(8, 1fr);
  max-height: 90vh;
  background-color: white;
  border-radius: 5px;

`;

function ModalForm({
  handleResetPage,
  isOpen,
  isForeign,
  setAdvanced,
  handleUpdate,
  closeModal,
  state
}) {
  const renderFields = () => {
    return map(advFormFields(), (field) => {
      const { propName, label, className, options, scrollLimit, placeholder, isFlipped, maxLength, max, min } = field;

      if (field.formType === 'TYPE_DROPDOWN') {
        return (
          <Dropdown
            key={propName}
            value={state[propName]}
            propName={propName}
            label={label}
            isFlipped={isFlipped}
            className={className}
            scrollLimit={scrollLimit}
            options={options}
            placeholder={placeholder}
            onChange={handleUpdate}
          />
        );
      } else if (field.formType === 'TYPE_INPUT' || field.formType === 'TYPE_NUMBERINPUT') {
        return (
          <Input
            min={min}
            max={max}
            maxLength={maxLength}
            key={propName}
            value={state[propName]}
            isFlipped={isFlipped}
            className={className}
            propName={propName}
            label={label}
            placeholder={placeholder}
            onChange={handleUpdate}
          />
        );
      } else if(field.formType === 'TYPE_PLACEHOLDER') {
        return (
          <Input
            key={propName}
            value={''}
            className={'hidden-input col-1s'}
            propName={propName}
            label={label}
            placeholder={placeholder}
            onChange={handleUpdate}
          />
        )
      }
    });
  }

  const saveForm = () => {
    setAdvanced(true);
    closeModal();
  }

  return (
    <StyledModal
      className="Modal-Form"
      isOpen={isOpen}
      isForeign={isForeign}
      closeModal={closeModal}
      headerText="Advanced Options"
      width="80vw"
      btnObjs={[
        {
          text: 'Reset Page',
          style: 'secondary',
          onClick: (e) => handleResetPage(e, true),
        },
        {
          text: 'Save & Close',
          style: 'primary',
          onClick: saveForm
        }
      ]}
    >
      <ModalFormGrid>
      { renderFields() }
      </ModalFormGrid>
    </StyledModal>
  );
}

export default ModalForm;